<template lang="pug">
ConstructorioRecommendations(:pod-id='podId' :item-id='itemId' :num-results='3' :override-padding='true')
  template(#title='{ defaultTitle }')
    p(class='text-gray-darkest text-base font-bold leading-none pb-1') {{ defaultTitle }}

  template(#default='{ recommendations }')
    div(
      v-for='(result, index) in recommendations.results'
      :key='`${result.data?.variation_id}-${index}`'
      class='w-full p-2 border border-gray-light rounded-sm mb-3 flex gap-2 items-center'
      data-cnstrc-item='Recommendation'
      :data-cnstrc-item-id='result.data?.productLineSlug'
      :data-cnstrc-item-name='result.value'
      :data-cnstrc-item-variation-id='result.data?.variation_id'
      :data-cnstrc-strategy-id='result.strategy?.id'
      :data-cnstrc-item-price='result.data?.salePrice / 100'
    )
      img(
        v-if='result.data?.image'
        :key='result.data?.image.key'
        :alt='result.data?.image.title || ""'
        :src='getImageUrl(result.data?.image.key, result.data?.image.filename, 106, 80, 70, "fff")'
        width='106'
        height='80'
      )

      div(class='my-2 flex-1')
        UniversalLink(
          :link='`/p/${result.data?.productLineSlug}/`'
          class='inline-block text-black text-pretty font-medium leading-5 text-base'
        )
          InlineHtml(:text='result.data?.productLineName')
        div
          span(
            :data-discount='result.data?.hasDiscount'
            class='inline-block leading-9 text-gray-darkest text-lg font-bold mr-2'
          ) {{ formatCents(result.data?.salePrice) }}
          span(v-if='result.data?.hasDiscount' class='inline-block line-through text-sm text-gray-dark') {{ formatCents(result.data?.originalPrice) }}

      BaseFormCheckbox(
        :id='result.data?.variation_id'
        :name='result.data?.variation_id'
        :value='selectedItems.includes(result.data?.sku)'
        class='min-w-5'
        :classes='{ wrapper: "$reset flex items-center", decorator: "$reset border block relative h-5 w-5 mr-0 rounded bg-white peer-checked:ring-action text-transparent peer-checked:text-action", outer: "$reset formkit-disabled:opacity-50" }'
        @change='toggleItem(result.data?.sku)'
      )
</template>

<script setup lang="ts">
const { getImageUrl } = useUrls()
const route = useRoute()

const emit = defineEmits(['updateBundle'])

const { podId, itemId } = defineProps<{
  podId: string
  itemId?: string
}>()

const fitmentStore = useFitmentStore()
const selectedItems: Ref<AddItemsRequest[]> = ref([])

// We need to reset the selected items when fitment changes
// otherwise selected items before fitment changes will still exist in the array
watch(
  () => route.fullPath,
  () => {
    selectedItems.value = []
    emit('updateBundle', selectedItems.value)
  }
)

function toggleItem(sku: string) {
  const index = selectedItems.value.findIndex((item) => item.sku === sku)

  if (index === -1)
    selectedItems.value.push({
      sku,
      qty: 1,
      fitmentData: fitmentStore.$state,
    })
  else selectedItems.value.splice(index, 1)

  emit('updateBundle', selectedItems.value)
}
</script>
